export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer id="footer" className="bg-secondary-800 text-secondary-200">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-8 lg:gap-10">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-book-open-line text-lg text-background-50"></i>
              </div>
              <span className="font-heading font-bold text-xl text-background-50">飞飞漫画网</span>
            </div>
            <p className="text-sm text-secondary-300 leading-relaxed max-w-md">
              飞飞漫画网致力于为漫画爱好者提供最全面的漫画全集在线看服务，涵盖完结漫画、系列漫画大全、高人气连载等丰富内容。
              支持漫画全集免费阅读与下载，让每一位读者都能享受最优质的漫画阅读体验。
            </p>
            <div className="flex items-center gap-4 mt-5">
              <a href="#hero" className="w-9 h-9 flex items-center justify-center rounded-md bg-secondary-700 hover:bg-secondary-600 text-secondary-300 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-weibo-line text-base"></i>
              </a>
              <a href="#hero" className="w-9 h-9 flex items-center justify-center rounded-md bg-secondary-700 hover:bg-secondary-600 text-secondary-300 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-wechat-line text-base"></i>
              </a>
              <a href="#hero" className="w-9 h-9 flex items-center justify-center rounded-md bg-secondary-700 hover:bg-secondary-600 text-secondary-300 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-bilibili-line text-base"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-sm text-background-50 mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              <li><a href="#cards" className="text-sm text-secondary-300 hover:text-background-50 transition-colors no-underline">精选漫画</a></li>
              <li><a href="#ranking" className="text-sm text-secondary-300 hover:text-background-50 transition-colors no-underline">人气排行</a></li>
              <li><a href="#topics" className="text-sm text-secondary-300 hover:text-background-50 transition-colors no-underline">热门话题</a></li>
              <li><a href="#updates" className="text-sm text-secondary-300 hover:text-background-50 transition-colors no-underline">最新动态</a></li>
              <li><a href="#index" className="text-sm text-secondary-300 hover:text-background-50 transition-colors no-underline">漫画索引</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-sm text-background-50 mb-4">漫画分类</h4>
            <ul className="space-y-2.5">
              <li><a href="#topics" className="text-sm text-secondary-300 hover:text-background-50 transition-colors no-underline">热血漫画</a></li>
              <li><a href="#topics" className="text-sm text-secondary-300 hover:text-background-50 transition-colors no-underline">恋爱漫画</a></li>
              <li><a href="#topics" className="text-sm text-secondary-300 hover:text-background-50 transition-colors no-underline">悬疑推理</a></li>
              <li><a href="#topics" className="text-sm text-secondary-300 hover:text-background-50 transition-colors no-underline">国漫精选</a></li>
              <li><a href="#topics" className="text-sm text-secondary-300 hover:text-background-50 transition-colors no-underline">日漫经典</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-sm text-background-50 mb-4">合作伙伴</h4>
            <p className="text-sm text-secondary-400 leading-relaxed">
              更多合作伙伴信息持续更新中，敬请期待。
            </p>
          </div>
        </div>

        <div className="border-t border-secondary-700 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-secondary-400">
            &copy; {currentYear} 飞飞漫画网. 本站所有漫画内容仅供阅读交流，版权归原作者所有。
          </p>
          <div className="flex items-center gap-5">
            <a href="#hero" className="text-xs text-secondary-400 hover:text-secondary-200 transition-colors no-underline">关于我们</a>
            <a href="#faq" className="text-xs text-secondary-400 hover:text-secondary-200 transition-colors no-underline">常见问题</a>
            <a href="#contact" className="text-xs text-secondary-400 hover:text-secondary-200 transition-colors no-underline">联系我们</a>
          </div>
        </div>
      </div>
    </footer>
  );
}